<template>
  <MainTheme />
</template>

<script>
import MainTheme from './components/layout/MainTheme.vue'

export default {
  name: 'App',
  components: {
    MainTheme
  },
  async mounted() {
    // Initialize any CSS transitions by adding a class to the document
    document.documentElement.classList.add('theme-transitions')
  }
}
</script>

<style>
/* Apply transitions to avoid theme flash when switching */
.theme-transitions * {
  transition:
    background-color 0.2s ease-in-out,
    color 0.2s ease-in-out,
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
}
</style>
